
import Layout from "../../components/Layout";
import ODBCClient from "../../images/systemComponents/ODBCClient.png";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1 className="mb-4 ">
                    ODBC клиент
                </h1>

                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        Использование <b>ODBC (Open Database Connectivity) клиента</b> в SCADA NPT Compact позволяет решать задачи, связанные с интеграцией, обменом данными и взаимодействием с различными базами данных, отличными от базовых (PostgreSQL/SQLite). ODBC — это стандартный интерфейс для доступа к базам данных, который обеспечивает универсальный способ подключения к различным СУБД (системам управления базами данных).
                    </p>
                    <p>
                        Поддержка СУБД PostgreSQL и SQLite в SCADA NPT Compact осуществляется в базовой версии без необходимости добавления ODBC клиента.
                    </p>
                    <img
                        src={ODBCClient}
                        className="mb-4 w-100 "
                        alt="ODBC Клиент"
                    />

                    <p>Основные задачи, которые решает использование ODBC клиента в SCADA NPT Compact, включают:</p>

                    <ul className="mb-4 description__list">

                        <li className="mb-1 description__number-li"><b>Интеграция с базами данных</b>
                            <ul>
                                <li>ODBC обеспечивает универсальный интерфейс для работы с различными СУБД, что позволяет SCADA NPT Compact поддерживать широкий спектр баз данных без необходимости изменения кода, таким как:
                                    <ul>
                                        <li>Microsoft SQL Server</li>
                                        <li> MySQL</li>
                                        <li>и т.п.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Обмен данными с другими системами</b>
                            <ul>
                                <li>ODBC клиент - один из вариантов взаимодействия SCADA NPT Compact с другими приложениями и системами, такими как:
                                    <ul>
                                        <li>ERP-системы (например, SAP, 1С).</li>
                                        <li>MES-системы (Системы на базе <a className="text-links " href="https://npt-platform.ru/" target="_blank">NPT Platform</a>  ).</li>
                                        <li>BI-системы (Business Intelligence).</li>
                                    </ul>
                                </li>
                                <li>Это позволяет использовать данные SCADA для бизнес-аналитики, планирования и управления ресурсами.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Импорт и экспорт данных</b>
                            <ul>
                                <li>ODBC клиент позволяет SCADA NPT Compact импортировать данные из внешних баз данных (например, справочники, конфигурации) и экспортировать данные для дальнейшей обработки или анализа.
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Повышение отказоустойчивости</b>
                            <ul>
                                <li>ODBC клиент может быть настроен для работы с резервными базами данных, что повышает отказоустойчивость и непрерывность работы SCADA NPT Compact.
                                </li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Поддержка SQL-запросов</b>
                            <ul>
                                <li>ODBC клиент позволяет SCADA NPT Compact выполнять SQL-запросы к внешним базам данных, что обеспечивает гибкость в работе с данными, включая:
                                    <ul>
                                        <li>Выборку данных.</li>
                                        <li>Вставку, обновление и удаление записей.</li>
                                        <li>Создание и модификацию таблиц.</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>

                </div>

            </div>
        </div>
    </Layout>
}
